/* tslint:disable:max-classes-per-file */
import { mergeRightAllWithArrays } from "@zoovu/runner-browser-api";
import { animationsAndTransitionsConfigurationValues, ConfigurationValues, standardTextsConfigurationValues, ValuesConfigurationProvider } from "./values-configuration-provider";

export class CustomizedStandardTextsValuesConfigurationProvider extends ValuesConfigurationProvider {
    constructor(private readonly standardTextsConfigurationDiffValues: any) {
        super();
    }

    public provide(configurationValues: ConfigurationValues): any {
        switch (configurationValues) {
            case ConfigurationValues.StandardTexts:
                return mergeRightAllWithArrays(standardTextsConfigurationValues, this.standardTextsConfigurationDiffValues, "id").standardTexts;
            default:
                break;
        }
        return {};
    }
}
export class CustomizedAnimationsAndTransitionsValuesConfigurationProvider extends ValuesConfigurationProvider {
    constructor(private readonly animationsAndTransitionsConfigurationDiffValues: any) {
        super();
    }

    public provide(configurationValues: ConfigurationValues): any {
        switch (configurationValues) {
            case ConfigurationValues.AnimationsAndTransitions:
                return mergeRightAllWithArrays(animationsAndTransitionsConfigurationValues, this.animationsAndTransitionsConfigurationDiffValues).animationsAndTransitionsConfiguration;
            default:
                break;
        }
        return {};
    }
}
